module.exports = __webpack_public_path__ + "static/img/ms.b0153046.png";